import _ from "@lodash";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import MobileDetect from "mobile-detect";
import React from "react";
import reducer from "./Store/Reducers/VincularOportunidadeReducer";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/VincularOportunidadeActions";
import OportunidadeCard from "./OportunidadeCard";
import { FuseAnimate } from "@fuse";
import { Card, Radio, Typography } from "@material-ui/core";

const md = new MobileDetect(window.navigator.userAgent);

class VincularOportunidade extends XAPPComponent {

    componentDidMount() {
        this.listFilter();
    }

    componentDidUpdate(prevProps, prevState) {
        const { VincularOportunidade } = this.props;

        if (VincularOportunidade.error) {
            this.props.showMessage({
                message: VincularOportunidade.error,
                variant: "error"
            });
            VincularOportunidade.error = null;
        }
        if (VincularOportunidade.warning) {
            this.props.showMessage({
                message: VincularOportunidade.warning,
                variant: "warning"
            });
            VincularOportunidade.warning = null;
        }
        if (VincularOportunidade.info) {
            this.props.showMessage({
                message: VincularOportunidade.info,
                variant: "success"
            });
            VincularOportunidade.info = null;
        }
    }

    listFilter = () => {
        const { list, xappRouteParams, idpessoaformulario = null, idagendamento } = this.props;
        let AFilter = {
            AND: [
                { "Campo": "idpessoaformulario", "Operador": "=", "Valor": idpessoaformulario },
                { "Campo": "idagendamento", "Operador": "=", "Valor": idagendamento }
            ]
        };
        list("SELECIONAR", xappRouteParams, !_.isNull(idpessoaformulario) && AFilter);

    };

    setParent = (_AIDParent) => {
        const { xappRouteParams, idagendamento } = this.props;
        this.props.setVinculoOportunidade({ idagendamento, "idparent": _AIDParent }, xappRouteParams, this.listFilter);
    };

    render() {
        const { VincularOportunidade, theme, xappRouteParams, idagendamento } = this.props;
        return (
            <React.Fragment>
                {!_.isUndefined(VincularOportunidade.data) && !_.isNull(VincularOportunidade.data) ?
                    <React.Fragment>
                        <Card
                            className={"flex w-full mb-16 rounded-4 relative"}
                            id={"card_desvinculado"}
                        >

                            <Radio
                                name="selected"
                                checked={_.findIndex(VincularOportunidade.data, { idparent: idagendamento }) === -1}
                                onClick={ev => ev.stopPropagation()}
                                onChange={ev => this.setParent(null)}
                            />
                            <div className="p-12">
                                <div className="flex">
                                    <Typography className="font-600">{"Desvinculado"}</Typography>
                                </div>
                            </div>
                        </Card>
                        {VincularOportunidade.data.map(card => (
                            <OportunidadeCard
                                card={card}
                                idagendamento={idagendamento}
                                xappRouteParams={xappRouteParams}
                                listFilter={this.listFilter}
                                setParent={this.setParent}
                                theme={theme}
                            />
                        ))}
                    </React.Fragment>
                    :
                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                        <div className="max-w-512 text-center">
                            <FuseAnimate delay={500}>
                                <Typography variant="h6" color="textSecondary" className="mb-16">
                                    {"Não existem registros cadastrados!"}
                                </Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
        list: Actions.list,
        setVinculoOportunidade: Actions.setVinculoOportunidade,
    }, dispatch);
}

function mapStateToProps({ VincularOportunidade, auth, Agendamento, fuse }) {
    return {
        user: auth.user.data,
        VincularOportunidade: VincularOportunidade,
        TagsAgendamento: Agendamento.TagFuncionalidadeReducer["agendamento"],
        theme: fuse.settings.mainTheme
    };
}

export default withReducer("VincularOportunidade", reducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(VincularOportunidade)));
